'use client';

import { c as _c } from "react/compiler-runtime";
import { ProdutoModal } from '@/features/home/components';
import { Button } from '@/shared/components/ui';
import { FeatherArrowRight, FeatherInfo } from '@subframe/core';
import { useState } from 'react';
import type { OfertaNotificacaoChatCardProps } from '../../../types/ofertaNotificacaoChatCardTypes';
export function OfertaNotificacaoChatCard(t0) {
  const $ = _c(13);
  const {
    onEnviar
  } = t0;
  const [isSaibaMaisOpen, setIsSaibaMaisOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-warning-50 text-warning-600 flex h-9 w-9 flex-none items-center justify-center rounded-[8px]" aria-hidden="true"><FeatherInfo className="h-4 w-4" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-start gap-3">{t1}<div className="flex min-w-0 flex-1 flex-col gap-2"><h3 className="text-default-font text-sm font-semibold">A Lexi concluiu as tentativas, mas não houve resposta</h3><p className="text-subtext-color text-sm leading-5">Todas as tentativas de contato incluídas nesta negociação já foram realizadas pela Lexi, mas a pessoa não respondeu.</p><p className="text-subtext-color text-sm leading-5">Como próximo passo, sugerimos enviar uma notificação extrajudicial para formalizar a cobrança.</p></div></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Button variant="neutral-tertiary" onClick={() => setIsSaibaMaisOpen(true)}>Saiba mais</Button>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FeatherArrowRight />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onEnviar) {
    t5 = <div className="flex flex-col gap-4 rounded-[16px] border border-solid border-neutral-200 bg-white p-4 shadow-sm sm:p-5">{t2}<div className="flex flex-wrap items-center justify-end gap-2">{t3}<Button variant="brand-primary" iconRight={t4} onClick={onEnviar}>Enviar notificação</Button></div></div>;
    $[4] = onEnviar;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = isSaibaMaisOpen ? "notificacao" : null;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsSaibaMaisOpen(false);
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== onEnviar || $[8] !== t6) {
    t8 = <ProdutoModal produtoKey={t6} onClose={t7} onAction={onEnviar} />;
    $[7] = onEnviar;
    $[8] = t6;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t5 || $[11] !== t8) {
    t9 = <>{t5}{t8}</>;
    $[10] = t5;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
}